<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-navigation`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M44 24c0-11.046-8.954-20-20-20S4 12.954 4 24s8.954 20 20 20 20-8.954 20-20zM8 24c0-8.837 7.163-16 16-16s16 7.163 16 16-7.163 16-16 16S8 32.837 8 24zm25.953-8.614a1 1 0 010 .697l-7.6 20.462a1 1 0 01-1.844.075l-3.938-8.44-8.44-3.94a1 1 0 01.074-1.843l20.462-7.6a1 1 0 011.286.59zm-13.63 8.264l7.601-2.824-2.823 7.602-1.52-3.258-3.259-1.52z"/></svg>
</template>
<script>

export default {
  name: 'IconNavigation',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
